import { Space } from 'antd';

import NavigationButton from './NavigationButton';
import ForwardBackwardsButton from './ForwardBackwardsButton';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import logo from '../../../../OpenMusic-logo.svg';
import { Tooltip } from '../../../Tooltip';

import useIsMobile from '../../../../utils/isMobile';

const HistoryNavigation = memo(() => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Space>
      <div 
        onClick={() => {
          navigate('/');
        }}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          margin: isMobile ? '0 8px' : '0 24px'
        }}
      >
        <img src={logo} alt="OpenMusic Logo" style={{ height: 32, width: 32, objectFit: 'contain' }} />
      </div>

      {!isMobile && (
        <div className='flex flex-row items-center gap-2 h-full'>
          <ForwardBackwardsButton flip />
          <ForwardBackwardsButton flip={false} />
        </div>
      )}
    </Space>
  );
});

export default HistoryNavigation;
